import React from 'react';
import { motion } from 'framer-motion';
import { 
  Smartphone, 
  CreditCard, 
  Upload as UploadIcon, 
  Zap, 
  GraduationCap,
  Shield
} from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Smartphone,
      title: "Custom homepage & product pages",
      description: "Mobile-first, conversion-optimised layouts that work perfectly on all devices."
    },
    {
      icon: CreditCard,
      title: "Checkout & payment setup",
      description: "Stripe/PayPal/local gateways; secure and PCI-ready for immediate transactions."
    },
    {
      icon: UploadIcon,
      title: "Full product onboarding",
      description: "We assist with CSV imports, images, SEO titles, and category setup."
    },
    {
      icon: Zap,
      title: "Performance & SEO basics",
      description: "Image optimisation, caching, GA4, and Meta Pixel for maximum visibility."
    },
    {
      icon: GraduationCap,
      title: "Training & 30-day support",
      description: "Handover, admin training, and follow-up optimizations to ensure success."
    },
    {
      icon: Shield,
      title: "Security & compliance",
      description: "SSL certificates, GDPR compliance, and secure hosting for customer trust."
    }
  ];

  return (
    <section id="features" className="section" style={{ background: '#f8fafc' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px'
          }}>
            What You Get
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
            Everything you need to launch and succeed
          </p>
        </motion.div>

        <div className="grid grid-3" style={{ gap: '24px' }}>
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
              className="card"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: '20px',
                background: 'white',
                border: '1px solid #e2e8f0',
                padding: '32px 24px'
              }}
            >
              <div style={{
                width: '64px',
                height: '64px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)'
              }}>
                <feature.icon size={28} color="white" />
              </div>
              
              <div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '600',
                  color: '#1e293b',
                  marginBottom: '12px',
                  lineHeight: '1.3'
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#64748b',
                  lineHeight: '1.6'
                }}>
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
